// 관리자 정보 인터페이스
export interface AdminInfo {
  admin_id: string;
  admin_name: string;
  role: string;
}

// 로그인 폼 데이터 인터페이스
export interface LoginFormData {
  admin_id: string;
  admin_pw: string;
}

// 로그인 상태 인터페이스
export interface AuthState {
  isLoggedIn: boolean;
  isLoading: boolean;
  adminInfo: AdminInfo | null;
  error: string | null;
}

// 토큰 정보 인터페이스
export interface TokenInfo {
  access_token: string;
  refresh_token: string;
}

// 로그인 유효성 검사 결과 인터페이스
export interface LoginValidation {
  isValid: boolean;
  errors: {
    admin_id?: string;
    admin_pw?: string;
  };
}

// 인증 에러 타입
export enum AuthErrorType {
  INVALID_CREDENTIALS = 'INVALID_CREDENTIALS',
  NETWORK_ERROR = 'NETWORK_ERROR',
  TOKEN_EXPIRED = 'TOKEN_EXPIRED',
  REFRESH_FAILED = 'REFRESH_FAILED',
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
}

// 인증 에러 인터페이스
export interface AuthError {
  type: AuthErrorType;
  message: string;
  details?: any;
} 